export default "__VITE_ASSET__f2645302__"